import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DfImageDirective } from '@df/module-image/df-image.directive';
import { HrefComponent } from '@df/ui/common/href/href.component';
import { OrdinalPipe } from '@df/ui/display/ordinal.pipe';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { PageViewAbstract } from '../../../catalog/ui/page/page-view.abstract';

@Component({
    selector: 'cms-blog-post',
    templateUrl: './cms-blog-post.component.html',
    standalone: true,
    imports: [CommonModule, DfImageDirective, HrefComponent, OrdinalPipe, TranslatePipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CmsBlogPostComponent extends PageViewAbstract {}
